import React, { useCallback, useContext, useEffect, useState } from "react";
import AuthContext from "../../../hooks/authContext";
import { formDateCustom } from "../../../services/helpers";
import CommunicationsCard from "./CommunicationsCard";
import styles from "../dashboard.module.scss";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import {
  fetchLatestChatMessages,
  getChannelList,
} from "../../../services/apiservices/messages";

const TeamMessages = React.memo(() => {
  const auth = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [channels, setChannels] = useState([]);
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;

  const getMessages = useCallback(async () => {
    try {
      getChannelList(companyId, async (res) => {
        const filtered = res?.filter((item) => item.status !== false);
        const filteredChannels =
          auth?.userProfile?.role === "Client"
            ? filtered?.filter((item) => item?.clientChannel === true && item?.client === clientId)
            : filtered;

        setChannels(filteredChannels);

        const channelIds = [...new Set(filteredChannels?.map((item) => item.id))];
        if (!channelIds.length) return;

        const messageData = await fetchLatestChatMessages(channelIds);
        if (!messageData?.length) return;

        let totalNotFoundCount = 0;
        const uniqueMessagesMap = new Map();

        messageData?.forEach((item) => {
          const key = `${item?.channelId}_${item?.sender?.userId}`;
          const existing = uniqueMessagesMap.get(key);
          if (!existing || existing?.createdOn < item?.createdOn) {
            uniqueMessagesMap.set(key, item);
          }
        });

        const newData = Array.from(uniqueMessagesMap.values()).map((item) => {
          const channelInfo = filteredChannels?.find((c) => c.id === item.channelId);
          if (Array.isArray(item?.readBy) && !item?.readBy.includes(auth?.userProfile?.id)) {
            totalNotFoundCount += 1;
          }
          return {
            user: (
              <>
                {item?.sender?.firstName ?? ""} {item?.sender?.lastName ?? ""}
                <span className={channelInfo?.clientChannel ? "text-[#6B7280] ml-5" : "ml-5"}>
                  ({channelInfo?.groupName ?? ""})
                </span>
              </>
            ),
            time: formDateCustom(item?.createdOn),
            preview: item?.message ?? "",
            id: channelInfo?.id,
          };
        });

        setCount(totalNotFoundCount);
        setData(newData?.slice(0, 5));
      });
    } catch (err) {
      console.error("Error loading team messages:", err);
    }
  }, [auth?.userProfile, companyId, clientId]);

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  return (
    <CommunicationsCard
      icon={<ChatBubbleOutlineOutlinedIcon className={styles.iconBlue} />}
      updates={data}
      title="Team Messages"
      count={count}
      to="/communications/message-board/live-chat"
      viewAll="/communications/message-board/live-chat"
      channels={channels}
    />
  );
});

export default TeamMessages;
